import { qportalApi } from './qportal-api';
const getAllInvoices = (request) => {
    return qportalApi.get(`Invoice/GetInvoicesByMonthAndYear`, {
        params: { month: request.month, year: request.year }
    });
};
const getInvoicesByStatus = (invoiceStatus, summaryGroup) => {
    return qportalApi.get(`Invoice/GetAllInvoicesByStatus/${invoiceStatus}`, { params: { summaryGroup } });
};
const AddUpdateInvoice = (request) => {
    return qportalApi.postForm(`Invoice/AddUpdateInvoice`, request);
};
const UpdateInvoiceStatus = (request) => {
    return qportalApi.postForm(`Invoice/UpdateInvoiceStatus`, request);
};
const getByInvoiceId = (request) => {
    return qportalApi.get(`Invoice/GetInvoiceById/${request}`);
};
const moveBasicInvoiceToNextStage = (invoiceId) => {
    const formData = new FormData();
    formData.append('Id', invoiceId);
    return qportalApi.postForm(`Invoice/MoveBasicInvoiceToNextStage`, formData);
};
const InvoiceApi = {
    getAllInvoices,
    AddUpdateInvoice,
    getInvoicesByStatus,
    getByInvoiceId,
    UpdateInvoiceStatus,
    moveBasicInvoiceToNextStage
};
export default InvoiceApi;
